import type { Media } from "@/types/media";

export const tvShows: Media[] = [
  {
    id: "t1",
    title: "长安风云录",
    titleEn: "Chronicles of Chang'an",
    kind: "tv",
    genres: ["古装", "历史"],
    region: "中国大陆",
    year: 2024,
    rating: 8.8,
    poster:
      "https://readdy.ai/api/search-image?query=grand%20chinese%20historical%20drama%20poster%20of%20an%20ancient%20capital%20city%20at%20dusk%20with%20palaces%20and%20lanterns%2C%20a%20young%20official%20in%20flowing%20robes%2C%20warm%20amber%20and%20deep%20red%20cinematic%20lighting%20and%20ornate%20detail&width=600&height=900&seq=tv-01-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20panorama%20of%20a%20magnificent%20ancient%20chinese%20capital%20city%20at%20golden%20dusk%2C%20layered%20palace%20roofs%20and%20glowing%20lanterns%2C%20warm%20amber%20and%20crimson%20tones%2C%20epic%20historical%20drama%20atmosphere%20and%20rich%20detail&width=1600&height=900&seq=tv-01-backdrop&orientation=landscape",
    director: "裴长安",
    cast: ["萧然", "云瑶", "傅言"],
    synopsis:
      "盛世长安之下暗流涌动，一位少年御史周旋于权谋与江湖之间，用一身风骨书写下一段荡气回肠的传奇。",
    episodes: 48,
    status: "已完结",
    views: 4260000,
  },
  {
    id: "t2",
    title: "都市白领日记",
    titleEn: "City Diaries",
    kind: "tv",
    genres: ["都市", "剧情"],
    region: "中国大陆",
    year: 2023,
    rating: 7.6,
    poster:
      "https://readdy.ai/api/search-image?query=modern%20urban%20drama%20poster%20of%20a%20bright%20city%20apartment%20at%20night%20with%20large%20windows%20and%20city%20skyline%2C%20warm%20lamp%20glow%20and%20cool%20evening%20tones%2C%20contemporary%20cinematic%20lifestyle%20mood%20and%20detail&width=600&height=900&seq=tv-02-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=modern%20urban%20drama%20poster%20of%20a%20bright%20city%20apartment%20at%20night%20with%20large%20windows%20and%20city%20skyline%2C%20warm%20lamp%20glow%20and%20cool%20evening%20tones%2C%20contemporary%20cinematic%20lifestyle%20mood%20and%20detail&width=600&height=900&seq=tv-02-poster&orientation=portrait",
    director: "林一",
    cast: ["苏曼", "周易", "夏乔"],
    synopsis:
      "三个性格迥异的年轻人在大城市合租，在职场与生活的鸡毛蒜皮之间，一点一点寻找属于自己的答案。",
    episodes: 36,
    status: "已完结",
    views: 2180000,
  },
  {
    id: "t3",
    title: "破晓行动",
    titleEn: "Operation Dawn",
    kind: "tv",
    genres: ["犯罪", "动作"],
    region: "中国大陆",
    year: 2024,
    rating: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=tense%20crime%20action%20series%20poster%20of%20a%20plainclothes%20officer%20under%20a%20rainy%20night%20overpass%20with%20distant%20city%20lights%2C%20cold%20blue%20grey%20with%20orange%20highlights%2C%20gritty%20cinematic%20atmosphere%20and%20detail&width=600&height=900&seq=tv-03-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=tense%20crime%20action%20series%20poster%20of%20a%20plainclothes%20officer%20under%20a%20rainy%20night%20overpass%20with%20distant%20city%20lights%2C%20cold%20blue%20grey%20with%20orange%20highlights%2C%20gritty%20cinematic%20atmosphere%20and%20detail&width=600&height=900&seq=tv-03-poster&orientation=portrait",
    director: "郑锋",
    cast: ["陆战", "沈冰"],
    synopsis:
      "缉毒警察卧底犯罪集团，在生死边缘坚守着心中的信念，静静等待破晓那一刻的到来。",
    episodes: 32,
    status: "已完结",
    views: 2860000,
  },
  {
    id: "t4",
    title: "星辰大海计划",
    titleEn: "Project Star Ocean",
    kind: "tv",
    genres: ["科幻"],
    region: "美国",
    year: 2025,
    rating: 8.7,
    poster:
      "https://readdy.ai/api/search-image?query=epic%20science%20fiction%20series%20poster%20of%20a%20vast%20interstellar%20fleet%20sailing%20past%20a%20ringed%20planet%2C%20glowing%20orange%20engine%20trails%20against%20deep%20space%2C%20grand%20cinematic%20scale%20and%20high%20detail&width=600&height=900&seq=tv-04-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20massive%20interstellar%20generation%20fleet%20traveling%20past%20a%20glowing%20ringed%20planet%2C%20orange%20engine%20trails%20and%20deep%20teal%20space%2C%20grand%20epic%20science%20fiction%20atmosphere%20and%20rich%20detail&width=1600&height=900&seq=tv-04-backdrop&orientation=landscape",
    director: "Alex Turner",
    cast: ["米娅·福特", "丹尼尔·凯"],
    synopsis:
      "人类首支星际移民舰队正式启航，船上数千人的命运，与一个惊天的航行真相紧紧相连。",
    episodes: 24,
    status: "更新至第24集",
    views: 3540000,
  },
  {
    id: "t5",
    title: "平凡一家人",
    titleEn: "An Ordinary Family",
    kind: "tv",
    genres: ["家庭", "喜剧"],
    region: "中国大陆",
    year: 2022,
    rating: 7.9,
    poster:
      "https://readdy.ai/api/search-image?query=heartwarming%20family%20comedy%20series%20poster%20of%20a%20cozy%20chinese%20family%20dining%20table%20full%20of%20home%20cooked%20dishes%2C%20warm%20golden%20evening%20lamplight%2C%20cheerful%20nostalgic%20cinematic%20mood%20and%20detail&width=600&height=900&seq=tv-05-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=heartwarming%20family%20comedy%20series%20poster%20of%20a%20cozy%20chinese%20family%20dining%20table%20full%20of%20home%20cooked%20dishes%2C%20warm%20golden%20evening%20lamplight%2C%20cheerful%20nostalgic%20cinematic%20mood%20and%20detail&width=600&height=900&seq=tv-05-poster&orientation=portrait",
    director: "孙莉",
    cast: ["王建国", "李秀兰"],
    synopsis:
      "一个普通中国家庭的日常，在柴米油盐的琐碎里，藏着最真实也最让人动容的幸福与感动。",
    episodes: 40,
    status: "已完结",
    views: 1740000,
  },
  {
    id: "t6",
    title: "迷雾山庄",
    titleEn: "Misty Manor",
    kind: "tv",
    genres: ["悬疑"],
    region: "英国",
    year: 2023,
    rating: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=brooding%20gothic%20mystery%20series%20poster%20of%20a%20remote%20stone%20manor%20surrounded%20by%20thick%20fog%20on%20a%20hill%2C%20single%20glowing%20window%20in%20amber%2C%20dark%20moody%20cinematic%20atmosphere%20and%20texture&width=600&height=900&seq=tv-06-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=brooding%20gothic%20mystery%20series%20poster%20of%20a%20remote%20stone%20manor%20surrounded%20by%20thick%20fog%20on%20a%20hill%2C%20single%20glowing%20window%20in%20amber%2C%20dark%20moody%20cinematic%20atmosphere%20and%20texture&width=600&height=900&seq=tv-06-poster&orientation=portrait",
    director: "丹尼尔·福斯特",
    cast: ["艾勒·琼斯", "索菲·布朗"],
    synopsis:
      "一栋与世隔绝的山庄里困着七位陌生人，随着交谈深入，他们发现彼此的故事都指向同一个秘密。",
    episodes: 20,
    status: "已完结",
    views: 1650000,
  },
  {
    id: "t7",
    title: "医者仁心",
    titleEn: "Healer's Heart",
    kind: "tv",
    genres: ["医疗", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=medical%20drama%20series%20poster%20of%20a%20bright%20hospital%20corridor%20with%20doctors%20in%20white%20coats%2C%20clean%20cool%20tones%20with%20warm%20amber%20accents%2C%20professional%20emotional%20cinematic%20lighting%20and%20detail&width=600&height=900&seq=tv-07-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=medical%20drama%20series%20poster%20of%20a%20bright%20hospital%20corridor%20with%20doctors%20in%20white%20coats%2C%20clean%20cool%20tones%20with%20warm%20amber%20accents%2C%20professional%20emotional%20cinematic%20lighting%20and%20detail&width=600&height=900&seq=tv-07-poster&orientation=portrait",
    director: "方哲",
    cast: ["顾清", "程越", "罗晓"],
    synopsis:
      "急诊室里的生死时速，一群医护用专业与温情，守护着每一位病人的希望与尊严。",
    episodes: 44,
    status: "更新至第44集",
    views: 2380000,
  },
  {
    id: "t8",
    title: "江湖客栈",
    titleEn: "Jianghu Inn",
    kind: "tv",
    genres: ["武侠", "古装"],
    region: "中国大陆",
    year: 2021,
    rating: 8.0,
    poster:
      "https://readdy.ai/api/search-image?query=wuxia%20series%20poster%20of%20a%20rustic%20ancient%20inn%20beside%20a%20mountain%20road%20at%20night%2C%20lanterns%20swaying%20and%20a%20sword%20on%20the%20table%2C%20warm%20amber%20and%20deep%20teal%20cinematic%20atmosphere%20and%20detail&width=600&height=900&seq=tv-08-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wuxia%20series%20poster%20of%20a%20rustic%20ancient%20inn%20beside%20a%20mountain%20road%20at%20night%2C%20lanterns%20swaying%20and%20a%20sword%20on%20the%20table%2C%20warm%20amber%20and%20deep%20teal%20cinematic%20atmosphere%20and%20detail&width=600&height=900&seq=tv-08-poster&orientation=portrait",
    director: "柳青",
    cast: ["莫问", "柳娘"],
    synopsis:
      "一间开在江湖要道上的客栈，往来的皆是刀光剑影，而掌着整座武林消息命脉的，正是那位笑意盈盈的老板娘。",
    episodes: 38,
    status: "已完结",
    views: 1520000,
  },
  {
    id: "t9",
    title: "青春纪事",
    titleEn: "Youth Chronicle",
    kind: "tv",
    genres: ["青春", "爱情"],
    region: "韩国",
    year: 2023,
    rating: 7.7,
    poster:
      "https://readdy.ai/api/search-image?query=bright%20youth%20romance%20series%20poster%20of%20students%20on%20a%20sunlit%20rooftop%20garden%20with%20flowers%20and%20string%20lights%2C%20fresh%20golden%20afternoon%20tone%2C%20nostalgic%20warm%20cinematic%20mood%20and%20detail&width=600&height=900&seq=tv-09-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=bright%20youth%20romance%20series%20poster%20of%20students%20on%20a%20sunlit%20rooftop%20garden%20with%20flowers%20and%20string%20lights%2C%20fresh%20golden%20afternoon%20tone%2C%20nostalgic%20warm%20cinematic%20mood%20and%20detail&width=600&height=900&seq=tv-09-poster&orientation=portrait",
    director: "朴民俊",
    cast: ["金秀妍", "李清雅"],
    synopsis:
      "一群高中生在城市的楼顶种下一片花园，也一并种下了关于梦想、友谊与初恋的青春记忆。",
    episodes: 30,
    status: "已完结",
    views: 1360000,
  },
  {
    id: "t10",
    title: "商海沉浮",
    titleEn: "Tides of Business",
    kind: "tv",
    genres: ["商战", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=modern%20business%20drama%20series%20poster%20of%20a%20glass%20office%20tower%20at%20blue%20hour%20reflected%20in%20wet%20glass%2C%20cool%20grey%20tones%20with%20warm%20amber%20accent%20lights%2C%20sleek%20cinematic%20atmosphere%20and%20detail&width=600&height=900&seq=tv-10-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=modern%20business%20drama%20series%20poster%20of%20a%20glass%20office%20tower%20at%20blue%20hour%20reflected%20in%20wet%20glass%2C%20cool%20grey%20tones%20with%20warm%20amber%20accent%20lights%2C%20sleek%20cinematic%20atmosphere%20and%20detail&width=600&height=900&seq=tv-10-poster&orientation=portrait",
    director: "吴征",
    cast: ["沈韬", "林薇"],
    synopsis:
      "创业者从零开始打拼，在资本与人性的巨大漩涡中一次次沉浮，只为守住最初的那份初心。",
    episodes: 42,
    status: "更新至第42集",
    views: 1960000,
  },
  {
    id: "t11",
    title: "未来纪元",
    titleEn: "Future Epoch",
    kind: "tv",
    genres: ["科幻"],
    region: "美国",
    year: 2024,
    rating: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=futuristic%20science%20fiction%20series%20poster%20of%20a%20glowing%20humanoid%20android%20face%20fragmented%20into%20light%20and%20circuit%20patterns%2C%20orange%20and%20cyan%20neon%20glow%20on%20dark%20background%2C%20sleek%20cinematic%20detail&width=600&height=900&seq=tv-11-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=futuristic%20science%20fiction%20series%20poster%20of%20a%20glowing%20humanoid%20android%20face%20fragmented%20into%20light%20and%20circuit%20patterns%2C%20orange%20and%20cyan%20neon%20glow%20on%20dark%20background%2C%20sleek%20cinematic%20detail&width=600&height=900&seq=tv-11-poster&orientation=portrait",
    director: "娜塔莉·格林",
    cast: ["泰勒·瑞德", "佐伊·陈"],
    synopsis:
      "在人工智能觉醒的时代，人类与机器的关系正一步步走向未知的边界，谁才是真正的未来。",
    episodes: 22,
    status: "已完结",
    views: 2140000,
  },
  {
    id: "t12",
    title: "悬案追踪",
    titleEn: "Cold Case Files",
    kind: "tv",
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    year: 2023,
    rating: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=chilling%20crime%20mystery%20series%20poster%20of%20an%20evidence%20board%20full%20of%20photos%20and%20red%20strings%20in%20a%20dim%20office%2C%20solitary%20desk%20lamp%20glow%20in%20warm%20amber%2C%20tense%20cinematic%20mood%20and%20texture&width=600&height=900&seq=tv-12-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=chilling%20crime%20mystery%20series%20poster%20of%20an%20evidence%20board%20full%20of%20photos%20and%20red%20strings%20in%20a%20dim%20office%2C%20solitary%20desk%20lamp%20glow%20in%20warm%20amber%2C%20tense%20cinematic%20mood%20and%20texture&width=600&height=900&seq=tv-12-poster&orientation=portrait",
    director: "高翔",
    cast: ["秦朗", "苏晚"],
    synopsis:
      "尘封多年的悬案被重新翻开，刑侦小组抽丝剥茧，只为还原每一个被时间遗忘的真相。",
    episodes: 34,
    status: "已完结",
    views: 2020000,
  },
  {
    id: "t13",
    title: "山海秘闻",
    titleEn: "Secrets of Mountains",
    kind: "tv",
    genres: ["奇幻", "古装"],
    region: "中国大陆",
    year: 2022,
    rating: 7.8,
    poster:
      "https://readdy.ai/api/search-image?query=oriental%20fantasy%20series%20poster%20of%20a%20misty%20ancient%20mountain%20village%20with%20a%20glowing%20spirit%20beast%20in%20the%20fog%2C%20jade%20green%20and%20amber%20magical%20light%2C%20mystical%20cinematic%20atmosphere%20and%20detail&width=600&height=900&seq=tv-13-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=oriental%20fantasy%20series%20poster%20of%20a%20misty%20ancient%20mountain%20village%20with%20a%20glowing%20spirit%20beast%20in%20the%20fog%2C%20jade%20green%20and%20amber%20magical%20light%2C%20mystical%20cinematic%20atmosphere%20and%20detail&width=600&height=900&seq=tv-13-poster&orientation=portrait",
    director: "云中",
    cast: ["白泽", "青鸢"],
    synopsis:
      "上古异兽重返人间的传说在村落间流传，一名少女意外成为解开这一切谜团的关键。",
    episodes: 36,
    status: "已完结",
    views: 1280000,
  },
  {
    id: "t14",
    title: "幸福三重奏",
    titleEn: "Happy Trio",
    kind: "tv",
    genres: ["爱情", "家庭"],
    region: "中国大陆",
    year: 2024,
    rating: 7.6,
    poster:
      "https://readdy.ai/api/search-image?query=warm%20neighborhood%20lifestyle%20series%20poster%20of%20three%20friendly%20apartment%20balconies%20with%20plants%20and%20string%20lights%20in%20the%20evening%2C%20cozy%20amber%20glow%2C%20heartwarming%20cinematic%20mood%20and%20detail&width=600&height=900&seq=tv-14-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=warm%20neighborhood%20lifestyle%20series%20poster%20of%20three%20friendly%20apartment%20balconies%20with%20plants%20and%20string%20lights%20in%20the%20evening%2C%20cozy%20amber%20glow%2C%20heartwarming%20cinematic%20mood%20and%20detail&width=600&height=900&seq=tv-14-poster&orientation=portrait",
    director: "温柔",
    cast: ["陆时", "安然"],
    synopsis:
      "三家人住在同一栋楼里，在鸡飞狗跳的邻里日常中，藏着最暖最真的人情味。",
    episodes: 28,
    status: "更新至第28集",
    views: 1420000,
  },
  {
    id: "t15",
    title: "铁血军魂",
    titleEn: "Iron Soul",
    kind: "tv",
    genres: ["战争", "历史"],
    region: "中国大陆",
    year: 2021,
    rating: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=epic%20war%20history%20series%20poster%20of%20a%20company%20of%20soldiers%20marching%20through%20snow%20covered%20mountains%20at%20dawn%2C%20warm%20firelight%20and%20grey%20cold%20tones%2C%20gritty%20cinematic%20atmosphere%20and%20detail&width=600&height=900&seq=tv-15-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20war%20history%20series%20poster%20of%20a%20company%20of%20soldiers%20marching%20through%20snow%20covered%20mountains%20at%20dawn%2C%20warm%20firelight%20and%20grey%20cold%20tones%2C%20gritty%20cinematic%20atmosphere%20and%20detail&width=600&height=900&seq=tv-15-poster&orientation=portrait",
    director: "铁峰",
    cast: ["赵刚", "李云"],
    synopsis:
      "战火纷飞的年代里，一支连队用青春与热血，默默守护着身后的山河与百姓。",
    episodes: 40,
    status: "已完结",
    views: 1880000,
  },
  {
    id: "t16",
    title: "秘境探险队",
    titleEn: "Expedition Unknown",
    kind: "tv",
    genres: ["冒险"],
    region: "英国",
    year: 2023,
    rating: 7.9,
    poster:
      "https://readdy.ai/api/search-image?query=adventure%20documentary%20series%20poster%20of%20explorers%20with%20torches%20inside%20an%20overgrown%20ancient%20temple%20ruin%20in%20the%20jungle%2C%20shafts%20of%20amber%20light%2C%20mysterious%20cinematic%20atmosphere%20and%20detail&width=600&height=900&seq=tv-16-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=adventure%20documentary%20series%20poster%20of%20explorers%20with%20torches%20inside%20an%20overgrown%20ancient%20temple%20ruin%20in%20the%20jungle%2C%20shafts%20of%20amber%20light%2C%20mysterious%20cinematic%20atmosphere%20and%20detail&width=600&height=900&seq=tv-16-poster&orientation=portrait",
    director: "克里斯·威尔",
    cast: ["艾玛·布朗", "奥利·怀特"],
    synopsis:
      "一支探险队深入无人之境，一步步揭开地图之外、被时间遗忘的古老文明遗迹。",
    episodes: 18,
    status: "已完结",
    views: 760000,
  },
];